import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { NotificationRoutingCard } from '@apps/web/components/settings/notification_routing_card';
import { NotificationsSettingsSection } from '@apps/web/components/settings/notifications_settings_section';
import { OfficeAssignmentCard } from '@apps/web/components/settings/office_assignment_card';
import { SlackSubscriptionsSection } from '@apps/web/components/settings/slack_subscriptions_section';
import {
    SettingsPageSections,
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/notifications')({
    // Accepts the deep-link params forwarded by the settings index route so the
    // email-unsubscribe and activity-return flows keep working after the swap.
    validateSearch: z.object({
        organizationId: z.string().optional(),
        unsubscribeEmailType: z.string().optional(),
        source: z.enum(['activity']).optional(),
        // Deep-link target from the auto-disable notice: scroll to and
        // briefly highlight the Automatic cleanup section.
        highlight: z.enum(['auto-cleanup']).optional(),
    }),
    component: NotificationsPage,
});

function NotificationsPage() {
    const { organizationId, gates } = useSettingsGates();
    return (
        <SettingsPageShell
            title="Notifications"
            description="Choose how you want to be notified."
        >
            <SettingsPageSections>
                {organizationId !== null ? (
                    <div className="space-y-6">
                        {gates.multiOffice ? (
                            <OfficeAssignmentCard
                                organizationId={organizationId}
                                variant="embedded"
                            />
                        ) : null}
                        <NotificationRoutingCard
                            careCoordinatorFeatureEnabled={
                                gates.careCoordinator
                            }
                            displayMode="section"
                            redesign={true}
                            organizationId={organizationId}
                        />
                    </div>
                ) : null}
                <NotificationsSettingsSection
                    organizationId={organizationId}
                    variant="embedded"
                />
                {organizationId !== null ? (
                    <SlackSubscriptionsSection
                        organizationId={organizationId}
                    />
                ) : null}
            </SettingsPageSections>
        </SettingsPageShell>
    );
}
